import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FoldersApiService } from 'src/app/api/services/folders-api.service';
import { FocusMeDirective } from '../../focus-me/focus-me.directive';
import { DialogHeaderComponent } from '../../modals/dialog-header/dialog-header.component';
import { ListItemKind } from 'src/app/components/scrolling-list';
import { FolderItem } from 'src/app/api/services/folder';

@Component({
  selector: 'new-folder-dialog',
  imports: [
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    DialogHeaderComponent,
    FocusMeDirective,
  ],
  providers: [],
  templateUrl: './new-folder-dialog.component.html',
  styleUrl: './new-folder-dialog.component.scss',
})
export class NewFolderDialogComponent {
  folderName = '';

  folderPath = '';
  parentFolderId = '';
  existingFiles: FolderItem[] = [];

  duplicateFolderSpecified = false;
  waitingForResponse = false;
  serverError = false;
  accessDenied = false;
  accessDeniedMessage = '';
  apiErrorMessage: string;

  constructor(
    public dialogRef: MatDialogRef<NewFolderDialogComponent>,
    private foldersApiService: FoldersApiService,
    @Inject(MAT_DIALOG_DATA) public data: NewFolderModalData,
  ) {
    this.existingFiles = data.existingFiles;
    this.parentFolderId = data.parentId;
  }

  private _fileNameExists(fileName: string) {
    for (var i = 0; i < this.existingFiles.length; i++) {
      if (this.existingFiles[i].name === fileName) {
        return true;
      }
    }
    return false;
  }

  ok() {
    if (!this.folderName) {
      this.folderName = '';
    }
    this.folderName = this.folderName.replace(/\//g, '');
    if (this._fileNameExists(this.folderName)) {
      this.duplicateFolderSpecified = true;
      return;
    }
    if (this.folderName !== '') {
      this.waitingForResponse = true;

      this.foldersApiService
        .add({
          name: this.folderName,
          kind: this.data.kind,
          parentId: this.data.parentId || null,
        })
        .then(() => {
          this.dialogRef.close(this.folderName);
        })
        .catch((err) => {
          console.error(err);
          if (err.status === 403) {
            this.accessDenied = true;
          } else {
            this.apiErrorMessage = err.message;
            this.serverError = true;
          }
        })
        .finally(() => {
          this.waitingForResponse = false;
        });
    }
  }

  cancel() {
    this.dialogRef.close(false);
  }
}

interface NewFolderModalData {
  existingFiles: FolderItem[];
  kind: ListItemKind;
  parentId?: string;
}
